import React from 'react'

function Smallerdevices() {
  return (
    <div style={{
        display:'grid',
        placeItems:'center',
        backgroundColor:'#541a31',
        minHeight:'100vh',
        fontWeight:'600',
        textAlign:'center',
        color:'#fff',
        fontSize:'2rem',
        padding:'5px'
    }}>
       
<p>Please turn on your dekstop site. This site is not supported on smaller devices</p>
    </div>
  )
}

export default Smallerdevices